import type { RecordData } from 'webapp-types';
import type { ModelName } from 'webapp/enums/enums';

import type ApplicationAdapter from 'webapp/adapters/application';
import type ApplicationSerializer from 'webapp/serializers/application';
import type { NormalizedRecord } from 'webapp/serializers/application';

export { default } from 'ember-data/store';

// WarpDrive's Store extends a base class typed as `any`, so the legacy methods (and any other member it doesn't
// declare) are `any` there. Declared here so they and their payloads are checked.
declare module '@warp-drive/core' {
	interface Store {
		// through the application serializer
		pushPayload(payload: RecordData.PushPayload): void;
		// through that model's serializer, so the payload keys are whatever it reads
		pushPayload(modelName: ModelName, payload: object): void;

		serializerFor(modelName: string): ApplicationSerializer; // all app serializers extend it
		adapterFor(modelName: string): ApplicationAdapter; // all app adapters extend it
		normalize(modelName: string, payload: object): NormalizedRecord;
	}
}
